import { Colors } from "@flatfile/design-system";
import { Shadows } from "./common/UI/Shadows.js";
const hexToRgba = (hex, opacity) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const defaultFontFamily = `Diatype, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`;
const defaultTheme = {
  backgroundColor: Colors.White,
  fontFamily: defaultFontFamily,
  baseFontSize: "13px",
  boxShadow: Shadows.default,
  rowHeight: 32,
  inputs: {
    radio: {
      color: Colors.ElectricBrand,
      borderColor: Colors.Pigeon600,
      borderRadius: "100%"
    },
    checkbox: {
      color: Colors.Electric700,
      borderColor: Colors.Pigeon400,
      borderRadius: "4px"
    },
    search: {
      borderColor: Colors.Pigeon200
    }
  },
  buttons: {
    iconColor: Colors.Pigeon700,
    backgroundColor: {
      hover: Colors.Pigeon200,
      active: Colors.Pigeon300
    },
    textColor: Colors.Midnight800,
    pill: {
      borderRadius: "10em",
      backgroundColor: Colors.White,
      color: Colors.Pigeon800,
      dropdown: {
        borderColor: Colors.Pigeon200
      }
    }
  },
  filters: {
    color: Colors.Midnight800,
    secondaryColor: Colors.Pigeon600,
    backgroundColor: Colors.White,
    secondaryBackgroundColor: Colors.Pigeon200,
    fontSize: "12px",
    outerBorder: "none",
    outerBorderRadius: "10em",
    innerBorderRadius: "10em",
    active: {
      color: Colors.White,
      secondaryColor: Colors.White,
      backgroundColor: Colors.Electric700,
      secondaryBackgroundColor: Colors.Electric600
    },
    error: {
      color: Colors.Pinata800,
      secondaryColor: Colors.Pinata500,
      activeBackgroundColor: Colors.Pinata900,
      secondaryBackgroundColor: Colors.Pinata700
    }
  },
  column: {
    width: 250,
    header: {
      color: Colors.Midnight800,
      changedColor: Colors.Jade900,
      addedColor: Colors.Jade900,
      removedColor: Colors.Pigeon700,
      autoGeneratedColor: Colors.Jade900,
      changedBackgroundColor: Colors.Jade100,
      addedBackgroundColor: Colors.Jade100,
      autoGeneratedBackgroundColor: Colors.Jade100,
      backgroundColor: Colors.Pigeon200,
      fontSize: "12px",
      fontWeight: 600,
      fontFamily: defaultFontFamily,
      borderColor: Colors.Pigeon400,
      dragHandle: {
        idle: Colors.Electric700,
        dragging: Colors.Electric600
      }
    },
    autoGeneratedBackgroundColor: hexToRgba(Colors.Jade100, 0.04),
    selected: {
      borderColor: Colors.Electric700,
      backgroundColor: Colors.Electric100
    }
  },
  indexColumn: {
    width: 50,
    color: Colors.Midnight800,
    fontSize: "12px",
    fontWeight: 600,
    fontFamily: defaultFontFamily,
    backgroundColor: Colors.Pigeon200,
    borderColor: Colors.Pigeon400,
    selected: {
      color: Colors.ElectricBrand,
      backgroundColor: Colors.Electric100
    }
  },
  table: {
    backgroundColor: Colors.White,
    borderColor: Colors.Pigeon400,
    rightOverflowGutter: 0,
    margin: {
      bottom: 100,
      right: 100
    }
  },
  cell: {
    borderColor: Colors.Pigeon400,
    color: Colors.Midnight800,
    secondaryColor: Colors.Pigeon700,
    removedColor: Colors.Pigeon700,
    addedColor: Colors.Jade900,
    addedBackgroundColor: Colors.Jade100,
    mutatedUnderlineColor: Colors.ElectricBrand,
    fontSize: "13px",
    borderRadius: "4px",
    selected: {
      backgroundColor: Colors.Electric100
    },
    active: {
      borderColor: Colors.Electric700,
      spinnerColor: Colors.ElectricBrand,
      boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1)",
      borderWidth: "1px"
    },
    disabled: {
      color: Colors.Pigeon800,
      backgroundColor: Colors.Pigeon100
    },
    error: {
      backgroundColor: Colors.Pinata100,
      color: Colors.Pinata900,
      borderColor: Colors.Pinata900
    },
    number: {
      fontFamily: `'PT Mono', serif`
    },
    warning: {
      backgroundColor: Colors.Sunflower100,
      color: Colors.Sunflower900,
      borderColor: Colors.Sunflower900
    }
  },
  lookupEditor: {
    color: Colors.Pigeon600,
    option: {
      backgroundColor: { hover: Colors.Pigeon100, active: Colors.Pigeon100 },
      borderRadius: { hover: "4px", active: "4px" }
    }
  },
  multiValue: {
    error: {
      svg: {
        color: Colors.Pinata900
      }
    },
    warning: {
      svg: {
        color: Colors.Sunflower900
      }
    },
    svg: {
      color: Colors.Pigeon400
    }
  },
  tooltip: {
    color: Colors.Pigeon800,
    backgroundColor: Colors.Pigeon100,
    fontSize: "14px",
    borderRadius: "2px"
  },
  boolean: {
    toggleDefault: Colors.Pigeon200,
    toggleDefaultIcon: Colors.Pigeon700,
    toggleChecked: Colors.ElectricBrand,
    toggleError: Colors.Pinata900,
    toggleWarning: Colors.Sunflower800,
    toggleRemoved: Colors.Pigeon400
  },
  loading: {
    color: Colors.ElectricBrand
  },
  modal: {
    underline: Colors.ElectricBrand
  },
  icon: {
    borderRadius: "4px"
  }
};
const darkTheme = defaultTheme;
export {
  darkTheme,
  defaultFontFamily,
  defaultTheme
};
